import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { ThreadQuickActions }
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/ThreadQuickActions';
import { getLightBorder } from 'Components/utils';
import useUserContext from 'Context/UserContext';
import { DataValueMap } from 'Helpers/Testing';
import {
  ThreadSubject,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadSubject';
import {
  ThreadParticipantGroup,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/ThreadParticipantGroup';
import usePopoverState from 'Hooks/usePopoverState';
import {
  ThreadParticipantListPopover,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipantListPopover';

const useStyles = buildUseStyles('DesktopThreadHeader', (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2),
    gap: theme.spacing(1.5),
    ...getLightBorder(theme, { bottom: true }),
  },
  spacer: {
    flexGrow: 1,
  },
}));

const DesktopThreadHeader = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { isAgent } = useUserContext();

  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
  } = usePopoverState({});

  const {
    selectedThreadResource,
  } = useMessagesContext();

  const threadParticipantsArray = selectedThreadResource?.attr('threadMembers').resources().list() || [];
  const memberThreadParticipant = threadParticipantsArray.find(threadParticipant => threadParticipant.attr('role') === 'Member');
  const memberThreadParticipantFound = !!memberThreadParticipant;

  return (
    <Box
      className={classNames(classes.root, className)}
      {...DataValueMap.init('messages-page-thread-header').build()}
    >
      <ThreadSubject threadResource={selectedThreadResource} />
      <ThreadParticipantGroup
        onClick={(e) => openPopover(e)}
        threadParticipants={threadParticipantsArray}
        max={3}
      />
      <ThreadQuickActions
        threadResource={selectedThreadResource}
        enableMemberNavigationLinks={isAgent && memberThreadParticipantFound}
        memberThreadParticipant={memberThreadParticipant}
      />
      <ThreadParticipantListPopover
        open={open}
        handleClose={(e) => handleClose(e)}
        anchorEl={anchorEl}
      />
    </Box>
  );
};

DesktopThreadHeader.defaultProps = {
  className: '',
};

DesktopThreadHeader.propTypes = {
  className: PropTypes.string,
};

export { DesktopThreadHeader };
